import sortDistributorGroupsAndJumps from '../sortDistributorGroupsAndJumps/sortDistributorGroupsAndJumps';
import sortMultipleAnswerMCGroupsAndJumps from '../sortMultipleAnswerMCGroupsAndJumps/sortMultipleAnswerMCGroupsAndJumps';

export default newState => {
  sortDistributorGroupsAndJumps(newState);
  sortMultipleAnswerMCGroupsAndJumps(newState);
};
